import React from 'react'
import styled from 'styled-components'

export default function Loader ({ width, height, ...rest }) {
  return (
   <Container customWidth={width} customHeight={height} {...rest}/>
  )
}

const Container = styled.div`
  display: block;
  background: #f3f3f3;
  width: ${props => props.customWidth};
  height: ${props => props.customHeight};
`